import { render, staticRenderFns } from "./mail-verification.vue?vue&type=template&id=68da5514&"
import script from "./mail-verification.vue?vue&type=script&lang=js&"
export * from "./mail-verification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports